<template>
  <div class="game_info">
    <van-tabs v-model="active" @click="tabClick">
      <van-tab
        v-for="(item, index) in tab1Arr"
        :key="item.tagId"
        :title="item.tagName"
        :id="item.tagId"
      >
        <listPage
          v-if="active == index"
          :class="item.tagName == '龙晶' ? '' : 'wide'"
          :tab2Arr="item.subTag"
          :listArr="listArr"
          @getList="getList"
        ></listPage>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import get from '@/api/get';
import listPage from '../../page/listPage.vue';
export default {
  components: {
    listPage
  },
  data() {
    return {
      active: '',
      tab1Arr: [],
      listArr: []
    };
  },
  computed: {},
  watch: {},
  methods: {
    init() {
      get.taglist().then((res) => {
        let data = res.data;
        if (data.code == 0) {
          this.tab1Arr = data.data;
          let id =
            this.tab1Arr[0].subTag.length != 0
              ? this.tab1Arr[0].subTag[0].id
              : this.tab1Arr[0].tagId;
          this.getList(id);
          $('body,html').animate({ scrollTop: 0 }, 0);
        } else {
          this.errorMessage(data);
        }
      });
    },
    //一级tab点击事件
    tabClick(index, title) {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      let id =
        JSON.stringify(this.tab1Arr[index].subTag) != '[]'
          ? this.tab1Arr[index].subTag[0].id
          : this.tab1Arr[index].tagId;
      this.getList(id);
    },
    //获取列表详情
    getList(id) {
      let form = {
        tagId: id
      };
      get.baikeList(form).then((res) => {
        let data = res.data;
        if (data.code == 0) {
          this.listArr = data.data;
        } else {
          this.errorMessage(data);
        }
      });
    },
    //错误提示
    errorMessage(data) {
      let code = data.code;
      if (code != 2050) {
        let voteErr = _code.code.vote;
        let msg = voteErr[code] ? voteErr[code] : voteErr['other'] + code;
        Toast(msg);
      }
    }
  },
  created() {
    if (this.$route.name == 'dqssgameInfoMainPage') {
      this.currentTab = 2;
    }
    this.$eventBus.$on('guidePageInit', () => {
      //路由直接访问时被indexInfo触发加载
      this.init();
    });
    if (this.$store.state.token) {
      //路由跳转时初始化加载
      this.init();
    }
  },
  mounted() {}
};
</script>
<style>
.ipad .guidePage .van-tabs--line .van-tabs__wrap {
  top: 1.5rem !important;
  padding-top: 0;
}
.dqss.ipad .dqss-guidepage .van-tabs--line .van-tabs__wrap {
  top: 1.2rem !important;
}
</style>
<style lang='scss' scoped>
.game_info {
  position: relative;
}
</style>